import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';
import API from '../../apiConfig';

function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(API.user.profile, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProfile(response.data.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch profile data' + err);
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!profile) return <div>No profile data available</div>;

  return (
    <div className="container mt-4">
      <h2>User Profile</h2>
      <div className="card">
        <div className="card-body">
          {/* <h5 className="card-title">{profile.fullName}</h5> */}
          <div class="row">
            <div class="col-md-6">
            <h5 className="card-title">{profile.fullName}</h5>
            </div>
            <div className="col-md-6 d-flex justify-content-end">

            <Link to="/manage-profile" className="btn btn-primary">
                Manage Profile
              </Link>
            </div>
          </div>
          <p className="card-text">Email: {profile.email}</p>
          <p className="card-text">Phone: {profile.phoneNumber}</p>
          <p className="card-text">Address: {profile.address}</p>
          <p className="card-text">Village: {profile.village}</p>
        </div>
      </div>
    </div>
  );
}

export default Profile;
